import { TravelRiskPackageCode } from '@app/domain/model/eshop/travel/TravelRiskPackageCode';

export function determineRiskDetails(code: Nullable<string>): string[] {
    switch (code) {
        case TravelRiskPackageCode.MedicalExpenses:
            return [
                'eshop.travel.risks.medicalExpenses.description',
                'eshop.travel.risks.medicalExpenses.insuranceAmount',
            ];
        case TravelRiskPackageCode.Accident:
            return ['eshop.travel.risks.accident.description', 'eshop.travel.risks.accident.insuranceAmount'];
        case TravelRiskPackageCode.Baggage:
            return ['eshop.travel.risks.baggage.description', 'eshop.travel.risks.baggage.insuranceAmount'];
        case TravelRiskPackageCode.CivilResponsibility:
            return [
                'eshop.travel.risks.civilResponsibility.description',
                'eshop.travel.risks.civilResponsibility.insuranceAmount',
            ];
        default:
            return [];
    }
}
